import { Component, computed, effect, input, OnInit, signal, ViewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FilterItemWithLabel } from '@vectronic/util';
import { ChipsFilterComponent } from '../chips-filter/chips-filter.component';
import { FilterHeaderComponent } from '../filter-header/filter-header.component';

@Component({
  selector: 'vectronic-multi-select-chip-filter',
  templateUrl: './multi-select-chip-filter.component.html',
  styleUrls: ['./multi-select-chip-filter.component.scss'],
  imports: [
    FilterHeaderComponent,
    ChipsFilterComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
})
export class MultiSelectChipFilterComponent<T> implements OnInit {
  title = input.required<string>();
  icon = input<string>();
  svgIcon = input<string>();
  availableFilterItems = input.required<FilterItemWithLabel<T>[]>();
  filtersForm = input.required<FormGroup>();
  controlName = input.required<string>();
  filterEnableControl = input.required<string>();

  @ViewChild(ChipsFilterComponent) private chipsFilter: ChipsFilterComponent<T>;

  selectedItems = signal<T[] | undefined>(undefined);
  isFilterHidden = signal(true);

  selectedFilterItems = computed<FilterItemWithLabel<T>[]>(() => {
    const items = this.selectedItems();
    if (Array.isArray(items)) {
      return items.map((i) => ({
        item: i,
        label: this.availableFilterItems()?.find((filterItem) => filterItem.item == i)?.label,
      }));
    }
    return [];
  });

  // noinspection JSUnusedGlobalSymbols
  focusFilterInputOnShow = effect(() => {
    if (!this.isFilterHidden() && !this.selectedItems()?.length) {
      setTimeout(() => this.chipsFilter?.focusInput(), 0);
    }
  });

  ngOnInit(): void {
    this.selectedItems.set(this.filtersForm().get(this.controlName()).value);
    this.isFilterHidden.set(!this.filtersForm().get(this.filterEnableControl()).value);
  }

  toggleFilter() {
    const isHidden = this.isFilterHidden();
    if (isHidden) {
      this.isFilterHidden.set(false);
    } else {
      this.isFilterHidden.set(true);
      this.selectedItems.set(undefined);
      this.filtersForm().get(this.controlName()).setValue(undefined);
    }
    this.filtersForm().get(this.filterEnableControl()).setValue(!this.isFilterHidden());
  }

  onSelectItem(event: FilterItemWithLabel<T>) {
    const newSelection = [...(this.selectedItems() || []), event.item];
    this.selectedItems.set(newSelection);
    this.filtersForm().get(this.controlName()).setValue(newSelection);
  }

  onDeleteItem(event: { item: FilterItemWithLabel<T>; index: number }) {
    const newSelection = this.selectedItems()?.toSpliced(event.index, 1);
    const finalSelection = newSelection?.length === 0 ? undefined : newSelection;
    this.selectedItems.set(finalSelection);
    this.filtersForm().get(this.controlName()).setValue(finalSelection);
  }
}
